export default {
  INTUMESCE: 'intumesce', // บวม
  PAIN: 'pain',
  INFLAME: 'inflame' // อักเสบ
}
